import React, {JSX} from "react";
import { useSelector } from "react-redux";
import { UtenteLogged } from "./authenticationSlice";
import { PermissionTypes } from "./permissionsGroups";
import { RootState } from "../../redux/store";

import { Navigate, useLocation } from "react-router-dom";
import {useAutorizzazioneGruppi} from "./useAutorizzazioneGruppi";

interface PrivateRouteProps {
	gruppiAutorizzati: PermissionTypes[];
	element: JSX.Element;
}

const PrivateRoute = ({ gruppiAutorizzati, element }: PrivateRouteProps) => {
	const location = useLocation();
	const utente = useSelector<RootState, UtenteLogged>(
		(state) => state.authentication.utenteLogged
	);
	const utenteAutorizzato = useAutorizzazioneGruppi(gruppiAutorizzati);

	if (utente.isLogged) {
		if (utenteAutorizzato) {
			return element;
		} else {
			return (
				<Navigate
					replace
					to={{
						pathname: "/notPermitted",
						// state: { from: routeProps.location },
					}}
				/>
				// <Redirect
				//   to={{ pathname: "/notPermitted", state: { from: routeProps.location } }}
				// />
			);
		}
	} else {
		return (
			<Navigate
				to="/signin"
				state={{ from: { pathname: location.pathname } }}
			/>
		);
	}
};

export default PrivateRoute;
